export default {
  mainRateTitle: {
    id: 'review_funnel_question_main_rate_title',
    defaultMessage: 'How was your {model} order?',
  },
  mainRateSubtitle: {
    id: 'review_funnel_question_main_rate_subtitle',
    defaultMessage: 'We want to hear from you so we can improve.',
  },
  overallPerformanceTitle: {
    id: 'review_overall_performance_title',
    defaultMessage: 'Overall performance',
  },
  aestheticAppearanceTitle: {
    id: 'review_aesthetic_appearance_title',
    defaultMessage: 'Appearance',
  },
  batteryTitle: {
    id: 'review_battery_title',
    defaultMessage: 'Battery',
  },
  cameraTitle: {
    id: 'review_camera_title',
    defaultMessage: 'Lens & Camera',
  },
  accessoriesTitle: {
    id: 'review_accessories_title',
    defaultMessage: 'Accessories',
  },
  shippingTitle: {
    id: 'review_shipping_title',
    defaultMessage: 'Shipping',
  },
  packagingCleanlinessTitle: {
    id: 'review_packaging_cleanliness_title',
    defaultMessage: 'Packaging & cleanliness',
  },
  validationText: {
    id: 'review_form_validation_text',
    defaultMessage: 'No response, no opinion.',
  },
  fileInputMaxSizeError: {
    id: 'review_collection_photo_picker_error_too_big',
    defaultMessage: 'Upload a file under 10 MB.',
  },
} as const
